import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { Role } from '../../../../../../@types/types';

const validateSearch = z.object({
  role: z.nativeEnum(Role)
});

export const Route = createFileRoute('/_auth/auth/register_/register')({
  validateSearch
});
